// import 'core-js/actual/promise';      // Para IE 11
// import 'regenerator-runtime/runtime'; // Para IE 11
import { getCookie, fadeIn, fadeOut, formToJson, debounce, fetch$ } from 'dascat-utils';
import { toggleLoader, showFormErrors, showFormGlobalError } from './shared';
import '../css/part_form.css';


function ready() {

  const fileUploadField = document.getElementById('receipt_image');
  const file = fileUploadField.files[0];

  showUploadedFile(file);

  fileUploadField.addEventListener('change', () => {
    const file = fileUploadField.files[0];
    showUploadedFile(file);
  });

  const getSMSCodeButtonEl = document.getElementById('get-sms-code');
  if (getSMSCodeButtonEl != null) {
    getSMSCodeButtonEl.addEventListener('click', debounce(async (ev) => {

      const mobileEl = document.getElementById('mobile');
      const mobileValidityState = mobileEl.validity;
      const mobileWrapper = document.getElementById('mobile-wrapper');

      if (mobileValidityState.valueMissing) {
        mobileEl.setCustomValidity(mobileMissingValMsg);
      } else if (mobileValidityState.patternMismatch) {
        mobileEl.setCustomValidity(mobilePatternMismatchMsg);
      } else {
        mobileEl.setCustomValidity('');
      }
      if (mobileEl.reportValidity()) {
        toggleLoader(true);
        try {
          const res = await fetch$('/participa/get_code/', {
            method: 'POST',
            headers: {"X-CSRFToken": getCookie('csrftoken')},
            body: JSON.stringify({mobile: mobileEl.value}),
          });
          toggleLoader(false);
          if (res.success) {
            const err_div = document.getElementById('mobile-error-div');
            if (err_div !== null) {
              err_div.innerHTML = '';
              err_div.style.display = 'none';
            }
            const success_div = document.getElementById('mobile-success-div');
            if (success_div === null) {
              mobileWrapper.insertAdjacentHTML('afterend', `<div id='mobile-success-div' class='dc-input-validation-success-message'>${codeSentMsg}</div>`);
            } else {
              success_div.innerHTML = codeSentMsg;
              success_div.style.display = 'block';
            }
          } else {
            const success_div = document.getElementById('mobile-success-div');
            if (success_div !== null) {
              success_div.innerHTML = '';
              success_div.style.display = 'none';
            }
            const err_div = document.getElementById('mobile-error-div');
            if (err_div === null) {
              mobileWrapper.insertAdjacentHTML('afterend', `<div id='mobile-error-div' class='dc-input-validation-error-message'>${res.error}</div>`);
            } else {
              err_div.innerHTML = res.error;
              err_div.style.display = 'block';
            }
          }
        } catch (e) {
          toggleLoader(false);
          console.log(e)
          const success_div = document.getElementById('mobile-success-div');
          if (success_div !== null) {
            success_div.innerHTML = '';
            success_div.style.display = 'none';
          }
          const err_div = document.getElementById('mobile-error-div');
          if (err_div === null) {
            mobileWrapper.insertAdjacentHTML('afterend', `<div id='mobile-error-div' class='dc-input-validation-error-message'>${codeErrorMsg}</div>`);
          } else {
            err_div.innerHTML = codeErrorMsg;
            err_div.style.display = 'block';
          }
          return;
        }
      }
    }));
  }

  const submitButtonEl = document.getElementById('submit-button');
  if (submitButtonEl != null) {
    submitButtonEl.addEventListener('click', debounce(async (ev) => {
      const formEl = document.getElementById("submit-form");
      if (!formEl.reportValidity()) {
        return;
      }
      toggleLoader(true);
      try {
        const {data, multipart} = formToJson(formEl);
        const res = await fetch$(window.location.pathname, {
          method: 'POST',
          headers: { "X-CSRFToken": getCookie('csrftoken') },
          body: data
        }, 10000, true);

        if (res.success) {

          try {
            dataLayer.push( {
              'event': 'email_validate',
              'festival': res.festival
            });
          } catch {}

          if (res.validation) {
            const feedbackEl = document.getElementById("feedback-success");
            fadeOut(formEl, 200, () => {
              formEl.style.display = 'none';
              fadeIn(feedbackEl, 200, () => {
                toggleLoader(false);
              });
            });
            window.scrollTo(0, 0);
          } else {
            const referalLinkEl = document.getElementById('copy-text-input');
            if (referalLinkEl !== null) {
              referalLinkEl.value = res.referal_link;
            }
            const feedbackEl = document.getElementById("feedback-success-validated");
            fadeOut(formEl, 200, () => {
              formEl.style.display = 'none';
              fadeIn(feedbackEl, 200, () => {
                toggleLoader(false);
              });
            });
            window.scrollTo(0, 0);
          }

        } else {
          toggleLoader(false);
          showFormErrors(formEl, res.errors);
        }
      } catch (e) {
        console.log(e)
        toggleLoader(false);
        showFormGlobalError(formEl, globalErrorMsg);
        return;
      }

    }));

  }
}

const showUploadedFile = (file) => {
  const fileUploadField = document.getElementById('receipt_image');
  const fileName = file?.name;

  if (fileName) {
    const fileUploadUpload = document.getElementById('dropzone-file-upload');
    const fileUploadWrapper = document.getElementById('dropzone-file-wrapper');

    // Create a new div to hold the file name and remove button
    const fileDiv = document.createElement('div');
    fileDiv.classList.add('file-wrapper');
    fileUploadWrapper.appendChild(fileDiv);

    // Create a new span to display the file name
    const fileNameSpan = document.createElement('span');
    fileNameSpan.textContent = file.name;
    fileDiv.classList.add('file-name');
    fileDiv.appendChild(fileNameSpan);

    // Create a new button to remove the file
    const removeButton = document.createElement('button');
    removeButton.textContent = 'Remover';
    removeButton.type = 'button';
    removeButton.classList.add('remove-file-button');
    removeButton.addEventListener('click', () => {
      fileUploadField.value = null;

      // Remove file div
      fileUploadWrapper.removeChild(fileDiv);

      // Show dropzone upload
      fileUploadUpload.style.display = 'flex';
    });
    fileDiv.appendChild(removeButton);

    // Hide dropzone upload
    fileUploadUpload.style.display = 'none';
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ready);
} else {
  ready();
}
